import React from 'react'
import Logo from '../logo/logo'
import { HorizontalStack, Icon } from '@ztechapps/webui.util'
import DbRestore from './db-restore'
import Profile from './profile/profile'
import { ToggleSidebarButton } from './ToggleSidebarButton'

export const HeaderBar = () => {
  return (
    <header id="header" className="header fixed-top d-flex align-items-center">
      <div className="d-flex align-items-center justify-content-between">
        <a href="/" className="logo d-flex align-items-center">
          <Logo />
          <span className="d-none d-lg-block">Payme</span>
        </a>
      </div>
      <ToggleSidebarButton />

      {/* End Logo */}

      <div className="search-bar">
        <form className="search-form d-flex align-items-center" method="POST" action="#">
          <input type="text" name="query" placeholder="Search" title="Enter search keyword" />
          <button type="submit" title="Search">
            <Icon name="magnifying-glass" />
          </button>
        </form>
      </div>
      {/* End Search Bar */}
      <nav className="header-nav ms-auto">
        <HorizontalStack gap={2} className="align-items-center">
          <DbRestore />
          <Profile />
        </HorizontalStack>
      </nav>
      {/* End Icons Navigation */}
    </header>
  )
}
